import { useState } from "react";
import { Run } from "./Run";
import { createEntityStore } from "../../common/entityStore";

export function MailOrderArticleReplaceRunPage() {
    const [useParamsStore] = useState(() => createEntityStore<RunParams>({
        data: {},
        id: null,
        propValidators: [
        ]
    }));
    return <Run name="MO article replace" hub="mailOrderArticleReplaceRun"
        useParamsStore={useParamsStore} />;
}

interface RunParams {
}
